import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog } from "@progress/kendo-react-dialogs";
import { LoadingPanel } from "./LoadingPanel";
import { addNotificationWithTimeout } from '../app/addNotificationWithTimeout';
import { handleResponse } from '../app/handleResponse';
import { getCSRFToken } from '../app/getCSRFToken';

import {
    FormInput
} from "./forms/form-components";

import './Login.scss';

export const ForgotPassword = () => {
    const dispatch = useDispatch();
        
    const [isLoading, setIsLoading] = useState(false);
    const [isPasswordResetLinkSent, setIsPasswordResetLinkSent] = useState(false);

    const emailValidator = (value) => {
        const emailRegex = new RegExp(/\S+@\S+\.\S+/);

        if (emailRegex.test(value) === false) {
            return "This field is required";
        }

        if (value.length > 100) {
            return "The maximum length is 100 characters";
        }

        return "";
    }

    const handleSubmit = (dataItem) => {
        setIsLoading(true);

        fetch(`/api/forgotpassword`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setIsLoading(false);
                setIsPasswordResetLinkSent(true);                
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
                setIsLoading(false);
            });
    }

    useEffect(() => {      
        const baseTitle = "OTT";
        document.title = "Forgot password";

        if (baseTitle !== "") {
            document.title += ` | ${baseTitle}`;
        }
    }, []);

    return (
        <>
            <Dialog className="forgotPassword">
                {isLoading ? <LoadingPanel /> : null}

                <h1>
                    Forgot password
                </h1>

                {isPasswordResetLinkSent
                    ?
                    <div>
                        The password reset email has been sent                
                    </div>
                    :
                    <Form
                        onSubmit={handleSubmit}
                        render={(formRenderProps) => (
                            <FormElement>
                                <fieldset className={"k-form-fieldset"}>
                                    <div className="mb-3 noFormField">
                                        Enter your email address and receive a link to reset your password.
                                    </div>
                                    <Field
                                        id={"emailAddress"}
                                        name={"emailAddress"}
                                        label="Email address"
                                        type={"email"}
                                        component={FormInput}
                                        validator={emailValidator}
                                        autoComplete="username"
                                        aria-label="Email address"
                                    />
                                </fieldset>
                                <div className="k-form-buttons">
                                    <Button
                                        themeColor={"primary"}
                                        type={"submit"}
                                        disabled={!formRenderProps.allowSubmit}
                                    >
                                        Send password reset email                                     
                                </Button>
                                </div>
                            </FormElement>
                        )}
                    />}
            </Dialog>
        </>
    );
}